var _style, _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "right-white_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".right-white_svg__st7{fill:none;stroke:#fff;stroke-width:65;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M782.4 512H310.6M533.3 249l263 263-263 263"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 512,
    r: 31.3,
    fill: "#fff"
  })));
}

export default SvgRightWhite;